export default __webpack_public_path__ + "static/media/CatholicDick.efe4abce.PNG";